import { cn } from "@/shared/lib/cn";
export interface BrandMarkProps { size?: number; className?: string }
/** The approved Afterimage symbol; currentColor follows the surrounding palette. */
export function BrandMark({ size = 30, className }: BrandMarkProps) {
  return <svg viewBox="0 0 64 64" width={size} height={size} fill="currentColor" aria-hidden="true" focusable="false" className={cn("block shrink-0", className)}>
    <path d="M18 6h24v12H22a4 4 0 0 0-4 4v20H6V18A12 12 0 0 1 18 6Zm28 52H22V46h20a4 4 0 0 0 4-4V22h12v24a12 12 0 0 1-12 12Z" />
  </svg>;
}
